/* Progressive enhancements: original resource rows and collection copy remain in the DOM. */
(() => {
  'use strict';
  const source = document.getElementById('astondiy-ux-strings');
  if (!source) return;
  const strings = JSON.parse(source.textContent);
  const t = (key, values = {}) => Object.entries(values).reduce((text, [name, value]) => text.replaceAll(`UX${name.toUpperCase()}UX`, String(value)), strings[key] || key);
  const el = (tag, text, className) => { const node = document.createElement(tag); if (text) node.textContent = text; if (className) node.className = className; return node; };
  document.querySelectorAll('[data-country-search]').forEach(input => {
    const panel = input.closest('.disclosure__list-wrapper');
    const rows = [...panel.querySelectorAll('[data-country-name]')];
    input.addEventListener('input', () => {
      const term = input.value.trim().toLocaleLowerCase();
      rows.forEach(row => { row.hidden = !row.dataset.countryName.toLocaleLowerCase().includes(term); });
      panel.querySelector('[data-country-empty]').hidden = rows.some(row => !row.hidden);
    });
  });
  if (document.body.dataset.astondiyPage === 'fault-codes') {
    const table = document.querySelector('main table');
    if (table && table.rows.length > 2) {
      const rows = [...table.rows].slice(1);
      const indexed = rows.map(row => ({ row, text: row.textContent.toLocaleLowerCase() }));
      const box = el('div', '', 'astondiy-lookup');
      const label = el('label', t('lookup')); label.htmlFor = 'astondiy-code-search';
      const controls = el('div', '', 'astondiy-lookup-controls');
      const input = el('input'); input.id = label.htmlFor; input.type = 'search'; input.autocomplete = 'off';
      const clear = el('button', t('clear')); clear.type = 'button';
      const status = el('p'); status.setAttribute('role', 'status'); status.setAttribute('aria-live', 'polite');
      const empty = el('p', t('no_results')); empty.hidden = true;
      const pager = el('div', '', 'astondiy-lookup-pager');
      const previous = el('button', t('previous')); previous.type = 'button';
      const next = el('button', t('next')); next.type = 'button';
      const pageLabel = el('span');
      controls.append(input, clear); pager.append(previous, pageLabel, next); box.append(label, controls, status, pager, empty); table.before(box);
      let page = 1;
      const render = () => {
        const terms = input.value.trim().toLocaleLowerCase().split(/\s+/).filter(Boolean);
        const matched = indexed.filter(item => terms.every(term => item.text.includes(term)));
        const total = Math.max(1, Math.ceil(matched.length / 50)); page = Math.min(page, total);
        rows.forEach(row => { row.hidden = true; });
        matched.slice((page - 1) * 50, page * 50).forEach(item => { item.row.hidden = false; });
        status.textContent = matched.length === 1 ? t('result') : t('results', { count: matched.length });
        pageLabel.textContent = t('page', { page, total });
        previous.disabled = page === 1; next.disabled = page === total; empty.hidden = matched.length !== 0;
      };
      input.addEventListener('input', () => { page = 1; render(); });
      clear.addEventListener('click', () => { input.value = ''; page = 1; render(); input.focus(); });
      previous.addEventListener('click', () => { page--; render(); });
      next.addEventListener('click', () => { page++; render(); });
      render();
    }
  }
  document.querySelectorAll('.TablePress').forEach((root, index) => {
    const hint = el('p', t('table_hint'), 'astondiy-table-hint'); root.before(hint);
    const enhance = () => {
      observer.disconnect();
      const input = root.querySelector('input[placeholder]');
      if (input && !input.dataset.astondiyLabel) {
        input.dataset.astondiyLabel = 'true';
        if (!input.id) input.id = `astondiy-parts-search-${index}`;
        const label = el('label', t('part_search'), 'astondiy-part-label'); label.htmlFor = input.id;
        input.closest('.MuiFormControl-root')?.before(label);
        input.setAttribute('aria-label', t('part_search'));
      }
      root.querySelectorAll('.dt-paging-button').forEach(button => {
        const text = button.textContent.trim();
        if (button.classList.contains('dt-paging-ellipsis')) return;
        const disabled = button.classList.contains('dt-paging-disabled');
        button.setAttribute('role', 'button'); button.tabIndex = disabled ? -1 : 0;
        button.setAttribute('aria-disabled', String(disabled));
        const key = { '«': 'first', '‹': 'previous', '›': 'next', '»': 'last' }[text];
        button.setAttribute('aria-label', key ? t(key) : t('table_page', { page: text }));
        if (button.classList.contains('current')) button.setAttribute('aria-current', 'page');
        else button.removeAttribute('aria-current');
      });
      root.querySelectorAll('th [aria-label]').forEach(control => {
        const label = control.getAttribute('aria-label');
        if (label.includes('[object Object]')) {
          const name = control.closest('th').querySelector('.Mui-TableHeadCell-Content-Wrapper')?.textContent.trim();
          if (name) control.setAttribute('aria-label', label.replace('[object Object]', name));
        }
      });
      root.querySelectorAll('.dt-table-scroll-container').forEach(panel => { panel.tabIndex = 0; panel.setAttribute('role', 'region'); panel.setAttribute('aria-label', t('table_label')); });
      observer.observe(root, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'aria-label'] });
    };
    const observer = new MutationObserver(enhance);
    root.addEventListener('keydown', event => {
      const button = event.target.closest('.dt-paging-button[role="button"]');
      if (button && button.getAttribute('aria-disabled') !== 'true' && (event.key === 'Enter' || event.key === ' ')) { event.preventDefault(); button.click(); }
    });
    enhance();
  });
  const description = document.querySelector('.collection-hero__description');
  if (description && description.textContent.trim()) {
    const details = el('details', '', 'astondiy-collection-intro');
    const summary = el('summary', t('collection_more'));
    description.before(details); details.append(summary, description);
    const mobile = matchMedia('(max-width:749px)');
    const resize = () => { details.open = !mobile.matches; };
    resize(); mobile.addEventListener('change', resize);
  }
})();
